let mTableCustomFilter:any;

export function initCustomFilter(db:any){
    mTableCustomFilter = db.table('customFilter')
}

export function updateCustomFilter(customFilter:any){
    return mTableCustomFilter.put(customFilter);
}

export function getCustomFilter(szId:any){
    return mTableCustomFilter.get(szId);
}

export function getCustomFilterList(){
    return mTableCustomFilter.toArray();
}

export function deleteCustomFilter(szId){
    return mTableCustomFilter.delete(szId);
}

/**
 * 获取收藏的
 */
export async function getCustomFilterFavorList(){
    return mTableCustomFilter.where('isFavirated').equals(1).toArray();
}